<template>
  <div class="home">
    <div class="main-content">
      <Banner />
      <partner></partner> 
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Banner from '../components/home/banner.vue'

import partner from '../components/home/partner.vue'
export default {
  name: 'Home',
  components: {
    Banner,
    partner
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    // 跳转外链
    openUrl (url) {
      window.open(url)
    }
  }
}
</script>
<style scoped lang="less">
@media (max-width: 980px) {

}
@media (min-width: 981px) {
  .home {
   
  }
}
</style>
